import axios from "../../../adapters/axios";

const register = async (userData: any) => {
  const response = await axios.post("signup", userData);

  return response.data;
};

// const login = async (userData: any) => {
//   const response = await axios.post("login", userData);
//   if (response.data) {
//     const persist_token = localStorage.getItem("remember_me");

//     if (persist_token === "true") {
//       localStorage.setItem("token", response.data.token);
//     } else {
//       sessionStorage.setItem("token", response.data.token);
//     }
//   }

//   return response.data.user;
// };

const login = async (user: {  email?: string;
  user_id?: string;
  password: string; }) => {
  const response = await axios.post("login", user);

  if (response.data?.token && response.data?.user) {
    const persist_token = localStorage.getItem("remember_me");

    if (persist_token === "true") {
      console.log("TOKEN1 =>", response.data.token);

      localStorage.setItem("token", response.data.token);
    } else {
      console.log("TOKEN1 =>", response.data.token);

      sessionStorage.setItem("token", response.data.token);
    }

    localStorage.setItem("userId", response.data.user.id);
  }

  return response.data;
};



const logout = async () => {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  localStorage.removeItem("userId");
  // Intentionally NOT removing "remember_me" — it is a user preference (checkbox
  // state), not session data. Removing it here caused whoAmI to look in the wrong
  // storage after the user re-logged-in, resulting in an auto-logout on refresh.
  window.location.reload();
};


const whoAmI = async () => {
  const persist_token = localStorage.getItem("remember_me");
  let token: any = "";

  if (persist_token === "true") {
    token = localStorage.getItem("token");
  } else {
    // "remember_me" is "false" or absent — check sessionStorage first, then
    // fall back to localStorage (covers the case where the user had previously
    // used "Keep me signed in" and the flag was cleared).
    token = sessionStorage.getItem("token") || localStorage.getItem("token");
  }

  if (token) {
    const response = await axios.get("whoAmI");
    localStorage.setItem("userId", response.data.id);
    return { user: response.data, token };
  } else {
    throw Error("No token found");
  }
};



const verifyMfa = async (payload: { tempToken: string; code: string }) => {
  try {
    const response = await axios.post("verify-code", payload);
    const persist_token = localStorage.getItem("remember_me");
    
    if (response.data?.token) {
      if (persist_token === "true") {
        localStorage.setItem("token", response.data.token);
      } else {
        sessionStorage.setItem("token", response.data.token);
      }
    }
    
    if (response.data?.user?.id) {
      localStorage.setItem("userId", String(response.data.user.id));
    }
    
    return response.data;
  } catch (error: any) {
    // Properly throw the error so it can be caught by the action
    throw error;
  }
};

const authService = {
  register,
  login,
  logout,
  whoAmI,
  verifyMfa,
};

export default authService;
